import React, { ReactElement } from 'react';
import NextImage from 'next/image';
import { baseTheme, Icon } from '@feast-it/ui/light';

import {
  ImageContainer,
  TopIllustrationWrapper,
  BottomIllustrationWrapper,
  HeroImage,
  TrustpilotStyledWidget,
} from './ImagesWrapper.styled';
import { useIsDarkTheme } from '../../../context/DarkThemeContext';

interface ImagesWrapperProps {
  imageSrc: string;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  verticalName: string;
}

const IMAGE_SIZE = {
  height: {
    small: 300,
    medium: 320,
    large: 540,
  },
  width: {
    small: 400,
    medium: 430,
    large: 720,
  },
};

const ICON_SIZE = {
  small: 120,
  medium: 160,
  large: 200,
};

export function ImagesWrapper({
  isDesktop,
  isTablet,
  imageSrc,
  verticalName,
}: ImagesWrapperProps): ReactElement {
  const layout = IMAGE_SIZE;
  const isDark = useIsDarkTheme();

  const width = isDesktop
    ? layout.width.large
    : isTablet
    ? layout.width.medium
    : layout.width.small;
  const height = isDesktop
    ? layout.height.large
    : isTablet
    ? layout.height.medium
    : layout.height.small;

  const size = isDesktop
    ? ICON_SIZE.large
    : isTablet
    ? ICON_SIZE.medium
    : ICON_SIZE.small;

  return (
    <ImageContainer>
      <TrustpilotStyledWidget />

      <TopIllustrationWrapper>
        {!isDark && (
          <Icon name="NewIllustration" size={size} fill="lightGrey" />
        )}
      </TopIllustrationWrapper>

      <BottomIllustrationWrapper>
        {!isDark && (
          <Icon name="NewIllustration" size={size} fill="lightGrey" />
        )}
      </BottomIllustrationWrapper>

      <HeroImage width={width} height={height}>
        <NextImage
          src={imageSrc}
          alt={verticalName ? verticalName + ' supplier' : 'supplier image'}
          width={width}
          height={height}
          sizes={`(max-width: ${baseTheme.breakpoints.small}) 400px, (max-width: ${baseTheme.breakpoints.medium}) 430px, 720px`}
          priority={true}
          fetchPriority="high"
          loading="eager"
          quality={65}
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            borderRadius: '8px',
            aspectRatio: `${width}/${height}`,
          }}
          placeholder="empty"
        />
      </HeroImage>
    </ImageContainer>
  );
}
